<template>
  <div v-if="session">
    <div>
      <v-slide-group v-model="tab" show-arrows>
        <v-slide-item
          v-for="item in tabs"
          :key="item.id"
          v-slot="{ active, toggle }"
        >
          <v-btn
            class="mx-2"
            :input-value="active"
            :color="active ? 'primary' : 'blue-grey lighten-4'"
            depressed
            rounded
            @click="toggle"
          >
            {{ item.nama }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </div>

    <div class="my-5">
      <CIkhtisarjab class="mb-5" v-if="tab == 0" />

      <CUraiantugas class="mb-5" v-if="tab == 1" />

      <CBahankerja class="mb-5" v-if="tab == 2" />

      <CPerangkat class="mb-5" v-if="tab == 3" />

      <CHasilkerja class="mb-5" v-if="tab == 4" />

      <CTanggungjawab class="mb-5" v-if="tab == 5" />

      <CWewenang class="mb-5" v-if="tab == 6" />

      <CPrestasikerja class="mb-5" v-if="tab == 7" />
    </div>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";

import CIkhtisarjab from "@/components/anjab/infojabatan/ikhtisarjab/view";
import CUraiantugas from "@/components/anjab/infojabatan/uraiantugas/view";
import CBahankerja from "@/components/anjab/infojabatan/bahankerja/view";
import CPerangkat from "@/components/anjab/infojabatan/perkerjab/view";
import CHasilkerja from "@/components/anjab/infojabatan/haskerjab/view";
import CTanggungjawab from "@/components/anjab/infojabatan/tanggungjawab/view";
import CWewenang from "@/components/anjab/infojabatan/wewenang/view";
import CPrestasikerja from "@/components/anjab/infojabatan/prekerdi/view";

export default {
  components: {
    CIkhtisarjab,
    CUraiantugas,
    CBahankerja,
    CPerangkat,
    CHasilkerja,
    CTanggungjawab,
    CWewenang,
    CPrestasikerja,
  },

  data: () => ({
    session: "",
    token: "",
    loading: false,

    tab: 0,

    tabs: [
      {
        id: "1",
        nama: "Ikhtisar",
      },
      {
        id: "2",
        nama: "Uraian Tugas",
      },
      {
        id: "3",
        nama: "Bahan Kerja",
      },
      {
        id: "4",
        nama: "Perangkat / Alat Kerja",
      },
      {
        id: "5",
        nama: "Hasil Kerja",
      },
      {
        id: "6",
        nama: "Tanggung Jawab",
      },
      {
        id: "7",
        nama: "Wewenang",
      },
      {
        id: "8",
        nama: "Prestasi Kerja yang diharapkan",
      },
    ],
  }),

  computed: {},

  watch: {},

  async mounted() {
    this.session = await JSON.parse(cookie.dec(cookie.get("myCookie")));
    this.token = await cookie.get("token");
  },

  methods: {},
};
</script>
